import { render } from "./PageG.vue?vue&type=template&id=26ea1baf"
import script from "./PageG.vue?vue&type=script&lang=js"
export * from "./PageG.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__